export default __webpack_public_path__ + "static/media/775.8a9dbe8e.png";